const objectionConsequencesStyle = {
  listStyle: {
    paddingInlineStart: "20px",
  },
};

export default objectionConsequencesStyle;
